/* eslint-disable no-lonely-if */
/** *
 *  2022-8版本 不同系统的一些参数区分
 *
 */
import { isJSONString, setFavicon } from "@/utils/utils";

function hasYjbParameter() {
  // Check if the URL contains the 'yjb' parameter
  const queryString = window.location.search;
  if (queryString) {
    const params = new URLSearchParams(queryString);
    if (params.has('yjb')) {
      localStorage.setItem('yjb', '1');
      return true;
    }
  }

  // Check if localStorage contains 'yjb' with value '1'
  const yjbValue = localStorage.getItem('yjb');
  if (yjbValue === '1') {
    return true;
  }

  // If neither condition is met, return false
  return false;
}


// alert(hasYjbParameter());
const logoUi = [
  {
    hostname: "gyl-logistics",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_bigdata_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_bigdata@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_bigdata_mini@2x.png"),
      },
    ],
    test: "物流管理系统",
    menuTest: "物流管理系统",
    productRecommendUrl: '',
    appId: "20001",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "tboss",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_tboss_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_tboss@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_tboss_mini@2x.png"),
      },
    ],
    test: "供应链平台",
    menuTest: "供应链平台",
    productRecommendUrl: '',
    appId: "20001",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "diting",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_diting_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_diting@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_diting_mini@2x.png"),
      },
    ],
    test: "集团风控策略平台",
    menuTest: "集团风控策略平台",
    productRecommendUrl: '',
    appId: "10013",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "paladin",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_paladin_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_paladin@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_paladin_mini@2x.png"),
      },
    ],
    test: "平台客户管理系统",
    menuTest: "平台客户管理系统",
    productRecommendUrl: '',
    appId: "10011",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "gyl",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_tboss_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_tboss@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_tboss_mini@2x.png"),
      },
    ],
    test: "供应链平台",
    menuTest: "供应链平台",
    productRecommendUrl: '',
    appId: "20001",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "boss",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_boss_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_boss@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_boss_mini@2x.png"),
      },
    ],
    test: "BOSS",
    menuTest: "BOSS",
    productRecommendUrl: '',
    appId: "10004",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "crm",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_crm_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_crm@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_crm_mini@2x.png"),
      },
    ],
    test: "商端CRM",
    menuTest: "商端CRM",
    productRecommendUrl: '',
    appId: "10007",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "sh",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_sh_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_sh@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_sh_mini@2x.png"),
      },
    ],
    test: "商户端",
    menuTest: "商户端",
    productRecommendUrl: '',
    appId: "10009",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "farm",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_xirang_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_xirang@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_xirang_mini@2x.png"),
      },
    ],
    test: "集团信息化平台",
    menuTest: "集团信息化平台",
    productRecommendUrl: '',
    appId: "90001",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "xirang",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_xirang_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_xirang@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_xirang_mini@2x.png"),
      },
    ],
    test: "集团信息化平台",
    menuTest: "集团信息化平台",
    productRecommendUrl: '',
    appId: "90001",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "ccs",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_ccs_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_ccs@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_ccs_mini@2x.png"),
      },
    ],
    test: "集团线索平台",
    menuTest: "集团线索平台",
    productRecommendUrl: '',
    appId: "10015",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "skydome",
    // eslint-disable-next-line global-require
    imgSrc: hasYjbParameter() ? require("@/assets/images/yjb_logo_login@3x.png") : require("@/assets/cy_img/logo_skydome_login@2x.png"),
    bgSrc: hasYjbParameter() ? require("@/assets/images/yjb_login_bg@2x.png") : require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: hasYjbParameter() ? require("@/assets/images/yjb_home_logo@2x.png") : require("@/assets/cy_img/logo_skydome@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: hasYjbParameter() ? require("@/assets/images/yjb_home_logo_small@2x.png") : require("@/assets/cy_img/logo_skydome_mini@2x.png"),
      },
    ],
    test: hasYjbParameter() ? "项目用车管理平台" : "工程项目设备管理SaaS系统",
    menuTest: "企业版",
    productRecommendUrl: '',
    appId: "10016",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "saas",
    // eslint-disable-next-line global-require
    imgSrc: hasYjbParameter() ? require("@/assets/images/yjb_logo_login@3x.png") : require("@/assets/cy_img/logo_skydome_login@2x.png"),
    bgSrc: hasYjbParameter() ? require("@/assets/images/yjb_login_bg@2x.png") : require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: hasYjbParameter() ? require("@/assets/images/yjb_home_logo@2x.png") : require("@/assets/cy_img/logo_skydome@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: hasYjbParameter() ? require("@/assets/images/yjb_home_logo_small@2x.png") : require("@/assets/cy_img/logo_skydome_mini@2x.png"),
      },
    ],
    test: hasYjbParameter() ? "项目用车管理平台" : "工程项目设备管理SaaS系统",
    menuTest: "企业版",
    productRecommendUrl: '',
    appId: "10016",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "ynjt",
    // eslint-disable-next-line global-require
    imgSrc: hasYjbParameter() ? require("@/assets/images/yjb_logo_login@3x.png") : require("@/assets/cy_img/logo_skydome_login@2x.png"),
    bgSrc: hasYjbParameter() ? require("@/assets/images/yjb_login_bg@2x.png") : require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: hasYjbParameter() ? require("@/assets/images/yjb_home_logo@2x.png") : require("@/assets/cy_img/logo_skydome@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: hasYjbParameter() ? require("@/assets/images/yjb_home_logo_small@2x.png") : require("@/assets/cy_img/logo_skydome_mini@2x.png"),
      },
    ],
    test: hasYjbParameter() ? "项目用车管理平台" : "工程项目设备管理SaaS系统",
    menuTest: "企业版",
    productRecommendUrl: '',
    appId: "10016",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "finance",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_finance_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_finance@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_finance_mini@2x.png"),
      },
    ],
    test: "财务工作台",
    menuTest: "财务工作台",
    productRecommendUrl: '',
    appId: "10019",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "themis",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_themis_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_themis@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_themis_mini@2x.png"),
      },
    ],
    test: "律师端",
    menuTest: "律师端",
    productRecommendUrl: '',
    appId: "10020",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "tms",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_tboss_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_tboss@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_tboss_mini@2x.png"),
      },
    ],
    test: "供应链平台物流",
    menuTest: "供应链平台物流",
    productRecommendUrl: '',
    appId: "20001",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "logistics",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_tboss_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_tboss@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_tboss_mini@2x.png"),
      },
    ],
    test: "物流管理平台",
    menuTest: "物流管理平台",
    productRecommendUrl: '',
    appId: "20008",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "cmhub",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_tboss_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_tboss@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_tboss_mini@2x.png"),
      },
    ],
    test: "客商融合平台",
    menuTest: "客商融合平台",
    productRecommendUrl: '',
    appId: "10025",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "bigdata",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_bigdata_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_bigdata@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_bigdata_mini@2x.png"),
      },
    ],
    test: "大数据平台",
    menuTest: "大数据平台",
    productRecommendUrl: '',
    appId: "10022",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "console",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_console_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_console@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_console_mini@2x.png"),
      },
    ],
    test: "console平台",
    menuTest: "console平台",
    productRecommendUrl: '',
    appId: "10023",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "workflow",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/images/znlh_ent_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_bigdata@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_bigdata_mini@2x.png"),
      },
    ],
    test: "审批中转",
    menuTest: "审批中转",
    productRecommendUrl: '',
    appId: "99999",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "investor",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_investor_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_investor@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_investor_mini@2x.png"),
      },
    ],
    test: "资方供应链平台",
    menuTest: "资方供应链平台",
    productRecommendUrl: '',
    appId: "20004",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
  {
    hostname: "srm",
    // eslint-disable-next-line global-require
    imgSrc: require("@/assets/cy_img/logo_investor_login@2x.png"),
    bgSrc: require("@/assets/images/left_pic@2x.png"),
    // eslint-disable-next-line global-require
    // eslint-disable-next-line global-require
    menuSrc: [
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_investor@2x.png"),
      },
      {
        // eslint-disable-next-line global-require
        src: require("@/assets/cy_img/logo_investor_mini@2x.png"),
      },
    ],
    test: "供应商门户",
    menuTest: "供应商门户",
    productRecommendUrl: '',
    appId: "20030",
    navigationBackColor: '#24304A', //导航背景色
    themeColor: '#356BFF', // 导航命中色&主题色
    navigationFoldColor: '#41516e', // 导航折叠色
  },
];

const getRepeat = () => {
  /** 供应链非常非常非常着急要 临时先这么写一下 */
  // 供应链物流测试环境
  if (window.location.hostname.toString().includes("gyl-logistics")) {
    return logoUi[0];
  }
  // 供应链平台生产环境
  if (window.location.hostname.toString().includes("tboss")) {
    return logoUi[1];
  }
  return logoUi.find((el) => {
    if (window.location.hostname.toString().includes(el.hostname)) {
      return el;
    }
  });
};
const getLogo = () => {
  // 判断当前域名
  let hostList;
  hostList = getRepeat();
  if (isJSONString("uiInfo") && process.env.NODE_ENV !== 'development') {
    const uiInfo = JSON.parse(localStorage.getItem("uiInfo")) || {};
    const uiFitment = JSON.parse(localStorage.getItem("ui_fitment")) || {};
    // eslint-disable-next-line no-inner-declarations
    function endowValue(a, b) {
      hostList[a] = uiInfo[b] || "";
    }
    const keys = [
      // {
      //   hostLisKey: "menuTest",
      //   uiInfoKey: "appHomeTitle", // 主页显示名称
      // },
      {
        hostLisKey: "test",
        uiInfoKey: "appLoginName", // 登录页显示名称
      },
      {
        hostLisKey: "imgSrc",
        uiInfoKey: "appLoginLogo", // 登录页显示logo
      },
      {
        hostLisKey: "bgSrc",
        uiInfoKey: "appLoginBackPic", // 登录页显示背景图
      },
      {
        hostLisKey: 'productRecommendUrl',
        uiInfoKey: "productRecommendUrl", // 关于我们
      }
    ];
    keys.forEach((m) => {
      endowValue(m.hostLisKey, m.uiInfoKey);
    });
    // eslint-disable-next-line no-unused-expressions
    hostList.menuSrc[0].src = uiFitment.menuLogo || uiInfo.appHomeLogo || "";  // 菜单大logo
    hostList.menuSrc[1].src = uiFitment.menuLogoSmall || uiInfo.appHomeLogoSmall || ""; // 菜单小logo
    hostList.menuTest = uiFitment.menuTitle || uiInfo.appHomeTitle || "", // 主页显示名称
      // 统一菜单主题色：固定为标准的一套，不再使用后端「UI装修」下发的导航色（logo/标题仍走装修）
    hostList.navigationBackColor = '#24304A';
    hostList.themeColor = '#356BFF';
    hostList.navigationFoldColor = '#41516e';
    let _ico = uiFitment.browserIco ? uiFitment.browserIco : (uiInfo.appHomeIcon || '');
    if (_ico) {
      setFavicon(_ico);
    }
    if (uiFitment.homeTitle) {
      document.title = uiFitment.homeTitle;
    }

    // eslint-disable-next-line no-unused-expressions
  } else if (isJSONString("ui_fitment") && process.env.NODE_ENV !== 'development' && hostList) {
    // 纯 token 直达不会经过登录页，只有当前租户的装修配置。
    // 仅覆盖首页菜单相关字段，避免影响原有 uiInfo 的登录页配置。
    const uiFitment = JSON.parse(localStorage.getItem("ui_fitment")) || {};
    if (uiFitment.menuLogo) {
      hostList.menuSrc[0].src = uiFitment.menuLogo;
    }
    if (uiFitment.menuLogoSmall) {
      hostList.menuSrc[1].src = uiFitment.menuLogoSmall;
    }
    if (uiFitment.menuTitle) {
      hostList.menuTest = uiFitment.menuTitle;
    }
    if (uiFitment.browserIco) {
      setFavicon(uiFitment.browserIco);
    }
    if (uiFitment.homeTitle) {
      document.title = uiFitment.homeTitle;
    }
  } else {
    if (!hostList) {
      hostList = {
        hostname: undefined,
        // eslint-disable-next-line global-require
        imgSrc: require("@/assets/images/jt.png"),
        bgSrc: require("@/assets/images/left_pic@2x.png"),
        // eslint-disable-next-line global-require
        // eslint-disable-next-line global-require
        menuSrc: [
          {
            // eslint-disable-next-line global-require
            src: require("@/assets/images/jtw.png"),
          },
          {
            // eslint-disable-next-line global-require
            src: require("@/assets/images/jtw.png"),
          },
        ],
        test: "本地-请选择系统",
        menuTest: "本地-请选择系统",
        productRecommendUrl: '',
        appId: undefined,
        navigationBackColor: '#24304A', //导航背景色
        themeColor: '#356BFF', // 导航命中色&主题色
        navigationFoldColor: '#41516e', // 导航折叠色
      };
    }
  }

  return hostList;
};

export {
  // eslint-disable-next-line import/prefer-default-export
  getLogo,
  hasYjbParameter
};
